import { Browser } from "@capacitor/browser";
import i18n from "../i18n";

// VitaStrong affiliate partnership (10% off with code, commission to owner).
export const VITASTRONG_URL = "https://www.vitastrong.co.uk/?bg_ref=iNrg5Jg45d";
export const VITASTRONG_CODE = "EMILIA10";
export const VITASTRONG_LOGO = "/vitastrong-logo.png";

// The VitaStrong partner perk is a UK-only affiliate. Disable the whole
// feature (in-game popup, Rewards page, More-menu entry) for Polish players.
export function partnerPerksEnabled() {
  const lang = (i18n.language || "en").toLowerCase();
  return !lang.startsWith("pl");
}

// Opens the affiliate link in the system browser (native) with a web fallback.
export async function openVitaStrong() {
  try {
    await Browser.open({ url: VITASTRONG_URL, presentationStyle: "popover" });
  } catch (_) {
    try {
      window.open(VITASTRONG_URL, "_blank", "noopener");
    } catch (__) {
      /* no-op */
    }
  }
}
